/** 左侧编辑区整块（含 Tabs + 可滚动内容），供 EditorPopup portal 锚定铺满 */
export const THEME_LAYOUT_LEFT_ROOT_ID = "theme-layout-left-root"
